export enum ConductTableColumns {
  ConductId = "conductId",
  ExternalId = "externalId",
  Person = "person",
  Role = "role",
  Competition = "competition",
  Season = "season",
  FixtureId = "fixtureId",
  ConductType = "conductType",
  Added = "added",
  Updated = "updated",
  Status = "status",
  ConductNotes = "conductNotes",
  DateOffenceLocal = "dateOffenceLocal",
  DateSuspendedFrom = "dateSuspendedFrom",
  DateSuspendedTo = "dateSuspendedTo",
  LifeSentence = "lifeSentence",
  FineAmount = "fineAmount",
  FineCurrency = "fineCurrency",
  FineStatus = "fineStatus",
  DateFinePaidLocal = "dateFinePaidLocal",
}
